<template>
  <v-tooltip top max-width="210px">
    <template v-slot:activator="{ on }">
      <div v-on="on" class="icon">
        <ReviewProcessingIcon />
      </div>
    </template>
    <span>
      {{ label }}
    </span>
  </v-tooltip>
</template>

<script>
import ReviewProcessingIcon from "@/components/ui/Icons/ReviewProcessingIcon.vue";

export default {
  name: "ReviewsCategoriesProcessingTooltip",
  components: {
    ReviewProcessingIcon
  },
  props: {
    label: {
      type: String
    }
  }
};
</script>
<style lang="scss">
.icon {
  height: 18px;
  width: 18px;
}
</style>
